// dependencies
import React from "react";
import { StyleSheet, TextStyle } from "react-native";

// components
import Text from "../Text";
import Link from "../Link";

type IProps = {
  label: string;
  current: boolean;
  to?: string;
};

const styles: StyleSheet.NamedStyles<{
  item: TextStyle;
  item__withTo: TextStyle;
}> = {
  item: {
    color: "#9b9b9b",
    paddingBottom: "0.3125em",
  },
  item__withTo: {
    borderStyle: "solid",
    borderBottomColor: "#cfdadd",
    borderBottomWidth: "0.0625em" as any,
  },
};

const Item: React.FunctionComponent<IProps> = (props): JSX.Element => {
  const { label, to, current } = props;

  if (null != to) {
    return (
      <Link
        style={[styles.item, styles.item__withTo]}
        to={to}
        aria-current={current ? "page" : undefined}
      >
        {label}
      </Link>
    );
  }

  return <Text style={styles.item}>{label}</Text>;
};

export default Item;
